// extracted by mini-css-extract-plugin
export default {"expandIconWrapper":"expandIconWrapper__FUgxad"};